import { createFileRoute } from '@tanstack/react-router';
import * as v from 'valibot';
import { Login } from '../../pages/login';

const validateSearch = v.object({
	redirect: v.optional(v.string()),
});

export const Route = createFileRoute('/auth/login')({
	component: Login,
	validateSearch,
});
